module.exports = __webpack_public_path__ + "static/img/no_cart.63e79961.png";